import React from 'react';

// import local file
import Header from '../../Header';

export default function CartHeader() {
  return <Header regular="Order" strong="Menu" classes="mb-4 pl-4 border-bottom" />;
}
